"use client";
import Button, { BtnType } from "@/components/common/buttons/Button";
import InputTextfield from "@/components/common/inputs/InputTextfield";
import ErrorMessage from "@/components/common/text/ErrorMessage";
import { cn } from "@/lib/utils";
import { Box, Typography } from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { useTranslations } from "next-intl";
import {
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
} from "react-hook-form";
import { RegisterForm } from "../page";
import classes from "../styles.module.scss";
interface Step3Props {
  register: UseFormRegister<any>;
  errors: FieldErrors;
  watch: (name: string) => string;
  clearErrors: UseFormClearErrors<RegisterForm>;
  control?: any;
  isLoadingSubmit?: boolean;
}

export default function Step2({
  register,
  errors,
  watch,
  clearErrors,
  control,
  isLoadingSubmit,
}: Step3Props) {
  const t = useTranslations("messages");
  const country = watch("country");

  return (
    <Box>
      <h2
        className="mt-2 mb-0 text-[14px] font-medium leading-[24px] tracking-[0.25px] text-gray-80 self-stretch"
        translation-key="register_page_sub_title_2"
      >
        {t("register_page_sub_title_2")}
      </h2>
      <Box className="flex flex-col gap-[16px] mt-5">
        <Box>
          <InputTextfield
            tabIndex={0}
            autoFocus
            translation-key="field_company"
            translation-key-placeholder="field_company_placeholder"
            title={t("field_company")}
            placeholder={t("field_company_placeholder")}
            {...register("company")}
            errorMessage={
              errors?.company?.message ? String(errors.company?.message) : null
            }
            className="w-full"
          />
        </Box>
        <Box>
          <InputTextfield
            tabIndex={1}
            translation-key="field_job_title"
            translation-key-placeholder="field_job_title_placeholder"
            title={t("field_job_title")}
            placeholder={t("field_job_title_placeholder")}
            {...register("title")}
            errorMessage={
              errors?.title?.message ? String(errors.title?.message) : null
            }
            className="w-full"
          />
        </Box>
        <Box className="flex flex-col">
          <Typography
            sx={{
              fontFamily: "Montserrat",
              color: errors.phone ? "var(--cimigo-danger)" : "var(--gray-80)",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "24px",
            }}
            translation-key="field_phone_number"
          >
            {t("field_phone_number")}
          </Typography>
          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <MuiTelInput
                {...field}
                tabIndex={2}
                value={field.value || ""}
                onChange={(value) => {
                  field.onChange(value);
                  clearErrors("phone");
                }}
                defaultCountry={
                  country ? ((country as any)?.shortName as any) : "VN"
                }
                className="w-full"
                variant="outlined"
                error={!!errors.phone}
              />
            )}
          />
          {errors.phone && (
            <ErrorMessage>
              {typeof errors.phone.message === "string"
                ? errors.phone.message
                : ""}
            </ErrorMessage>
          )}
        </Box>
      </Box>
      <Box className="flex flex-col gap-4">
        {/* <Button
          btnType={BtnType.Raised}
          className={cn(classes.btnAuthForm, "register-continue-button")}
          sx={{ textTransform: "none" }}
          type="submit"

        >
          <p className="m-0" translation-key="auth_button_continue">{t("auth_button_continue")}</p>
        </Button>
        <Button
          onClick={nextStep}
          btnType={BtnType.Text}
          className={cn(classes.btnAuthForm, "register-skip-button")}
          sx={{ textTransform: "none" }}

        >
          <p className="m-0" translation-key="auth_button_skip">{t("auth_button_skip")}</p>
        </Button> */}

        <Button
          isLoading={isLoadingSubmit}
          btnType={BtnType.Raised}
          className={cn(classes.btnAuthForm, "register-submit-button")}
          sx={{ textTransform: "none", mt: "40px" }}
          type="submit"
          translation-key="register_page_btn_register"
        >
          <p className="m-0">{t("register_page_btn_register")}</p>
        </Button>
      </Box>
    </Box>
  );
}
